import { Button, ButtonProps, Spinner } from "reactstrap";

interface BusyButtonProps {
  busy?: boolean;
}

const BusyButton = (props: ButtonProps & BusyButtonProps) => {
  const { busy, children, value, 'aria-label': ariaLabel, ...buttonProps } = props;

  const disabled = busy || buttonProps.disabled;

  return (
    <Button {...buttonProps}
      aria-label={ariaLabel ?? (value ? value.toString() : '')}
      disabled={disabled}>
      {busy ? <Spinner size="sm" aria-busy="true" /> : children}{value ? ` ${value}` : ''}
    </Button>
  );
}

export default BusyButton;
